Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _componentsReducer = require('./componentsReducer');

var _componentsReducer2 = _interopRequireDefault(_componentsReducer);

var _watchManReducer = require('./watchManReducer');

var _watchManReducer2 = _interopRequireDefault(_watchManReducer);

var _dependencyTreeReducer = require('./dependencyTreeReducer');

var _dependencyTreeReducer2 = _interopRequireDefault(_dependencyTreeReducer);

var _queryReducer = require('./queryReducer');

var _queryReducer2 = _interopRequireDefault(_queryReducer);

var _appbaseQueryReducer = require('./appbaseQueryReducer');

var _appbaseQueryReducer2 = _interopRequireDefault(_appbaseQueryReducer);

var _queryOptionsReducer = require('./queryOptionsReducer');

var _queryOptionsReducer2 = _interopRequireDefault(_queryOptionsReducer);

var _configReducer = require('./configReducer');

var _configReducer2 = _interopRequireDefault(_configReducer);

var _appbaseRefReducer = require('./appbaseRefReducer');

var _appbaseRefReducer2 = _interopRequireDefault(_appbaseRefReducer);

var _hitsReducer = require('./hitsReducer');

var _hitsReducer2 = _interopRequireDefault(_hitsReducer);

var _logsReducer = require('./logsReducer');

var _logsReducer2 = _interopRequireDefault(_logsReducer);

var _combinedLogsReducer = require('./combinedLogsReducer');

var _combinedLogsReducer2 = _interopRequireDefault(_combinedLogsReducer);

var _valueReducer = require('./valueReducer');

var _valueReducer2 = _interopRequireDefault(_valueReducer);

var _internalValueReducer = require('./internalValueReducer');

var _internalValueReducer2 = _interopRequireDefault(_internalValueReducer);

var _loadingReducer = require('./loadingReducer');

var _loadingReducer2 = _interopRequireDefault(_loadingReducer);

var _errorReducer = require('./errorReducer');

var _errorReducer2 = _interopRequireDefault(_errorReducer);

var _timestampReducer = require('./timestampReducer');

var _timestampReducer2 = _interopRequireDefault(_timestampReducer);

var _headersReducer = require('./headersReducer');

var _headersReducer2 = _interopRequireDefault(_headersReducer);

var _mapDataReducer = require('./mapDataReducer');

var _mapDataReducer2 = _interopRequireDefault(_mapDataReducer);

var _queryListenerReducer = require('./queryListenerReducer');

var _queryListenerReducer2 = _interopRequireDefault(_queryListenerReducer);

var _analyticsReducer = require('./analyticsReducer');

var _analyticsReducer2 = _interopRequireDefault(_analyticsReducer);

var _promotedResultsReducer = require('./promotedResultsReducer');

var _promotedResultsReducer2 = _interopRequireDefault(_promotedResultsReducer);

var _customDataReducer = require('./customDataReducer');

var _customDataReducer2 = _interopRequireDefault(_customDataReducer);

var _defaultQueryReducer = require('./defaultQueryReducer');

var _defaultQueryReducer2 = _interopRequireDefault(_defaultQueryReducer);

var _customQueryReducer = require('./customQueryReducer');

var _customQueryReducer2 = _interopRequireDefault(_customQueryReducer);

var _propsReducer = require('./propsReducer');

var _propsReducer2 = _interopRequireDefault(_propsReducer);

var _aggsReducer = require('./aggsReducer');

var _aggsReducer2 = _interopRequireDefault(_aggsReducer);

var _compositeAggsReducer = require('./compositeAggsReducer');

var _compositeAggsReducer2 = _interopRequireDefault(_compositeAggsReducer);

var _appliedSettingsReducer = require('./appliedSettingsReducer');

var _appliedSettingsReducer2 = _interopRequireDefault(_appliedSettingsReducer);

var _customHighlightReducer = require('./customHighlightReducer');

var _customHighlightReducer2 = _interopRequireDefault(_customHighlightReducer);

var _rawDataReducer = require('./rawDataReducer');

var _rawDataReducer2 = _interopRequireDefault(_rawDataReducer);

var _querySuggestionsReducer = require('./querySuggestionsReducer');

var _querySuggestionsReducer2 = _interopRequireDefault(_querySuggestionsReducer);

var _defaultPopularSuggestions = require('./defaultPopularSuggestions');

var _defaultPopularSuggestions2 = _interopRequireDefault(_defaultPopularSuggestions);

var _queryToHitsReducer = require('./queryToHitsReducer');

var _queryToHitsReducer2 = _interopRequireDefault(_queryToHitsReducer);

var _recentSearches = require('./recentSearches');

var _recentSearches2 = _interopRequireDefault(_recentSearches);

var _googleMapScriptReducer = require('./googleMapScriptReducer');

var _googleMapScriptReducer2 = _interopRequireDefault(_googleMapScriptReducer);

var _analyticsRefReducer = require('./analyticsRefReducer');

var _analyticsRefReducer2 = _interopRequireDefault(_analyticsRefReducer);

var _registeredComponentReducer = require('./registeredComponentReducer');

var _registeredComponentReducer2 = _interopRequireDefault(_registeredComponentReducer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = (0, _redux.combineReducers)({
  components: _componentsReducer2.default,
  customQueries: _customQueryReducer2.default,
  defaultQueries: _defaultQueryReducer2.default,
  customHighlightOptions: _customHighlightReducer2.default,
  settings: _appliedSettingsReducer2.default,
  watchMan: _watchManReducer2.default,
  queryList: _queryReducer2.default,
  queryOptions: _queryOptionsReducer2.default,
  dependencyTree: _dependencyTreeReducer2.default,
  appbaseRef: _appbaseRefReducer2.default,
  analyticsRef: _analyticsRefReducer2.default,
  config: _configReducer2.default,
  hits: _hitsReducer2.default,
  promotedResults: _promotedResultsReducer2.default,
  customData: _customDataReducer2.default,
  aggregations: _aggsReducer2.default,
  compositeAggregations: _compositeAggsReducer2.default,
  queryLog: _logsReducer2.default,
  combinedLog: _combinedLogsReducer2.default,
  selectedValues: _valueReducer2.default,
  internalValues: _internalValueReducer2.default,
  isLoading: _loadingReducer2.default,
  error: _errorReducer2.default,
  timestamp: _timestampReducer2.default,
  headers: _headersReducer2.default,
  mapData: _mapDataReducer2.default,
  queryListener: _queryListenerReducer2.default,
  analytics: _analyticsReducer2.default,
  props: _propsReducer2.default,
  rawData: _rawDataReducer2.default,
  querySuggestions: _querySuggestionsReducer2.default,
  defaultPopularSuggestions: _defaultPopularSuggestions2.default,
  queryToHits: _queryToHitsReducer2.default,
  recentSearches: _recentSearches2.default,
  urlValues: function urlValues() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return state;
  },
  googleMapScriptStatus: _googleMapScriptReducer2.default,
  lastUsedAppbaseQuery: _appbaseQueryReducer2.default,
  registeredComponentsTimestamps: _registeredComponentReducer2.default
});